import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { SkeletonBetslipComponent } from './skeleton-betslip.component';
import { SkeletonEventsComponent } from './skeleton-events.component';
import { SkeletonGridComponent } from './skeleton-grid.component';
import { SkeletonMarqueeComponent } from './skeleton-marquee.component';
import { SkeletonMinigamesComponent } from './skeleton-minigames.component';
import { SkeletonPage } from './skeleton-page.model';
import { SkeletonTopsportsComponent } from './skeleton-topsports.component';

@Component({
    selector: 'ms-skeleton-main-desktop',
    templateUrl: './skeleton-main-desktop.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SkeletonMarqueeComponent,
        SkeletonTopsportsComponent,
        SkeletonGridComponent,
        SkeletonBetslipComponent,
        NgClass,
        SkeletonMinigamesComponent,
        SkeletonEventsComponent,
    ],
})
export class SkeletonMainDestopComponent {
    device = inject(DeviceService);

    @Input() pageName: SkeletonPage;
    skeletonPage = SkeletonPage;
}
